import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { useTranslation } from 'react-i18next';
import TierIcon from '@wix/da-ds/pkg/Icons/16x16/Tier';
import StatisticsBar from './StatisticsBar';
/** Statistics bar specifically for Tiers to consolidate some code.
 *  Currently only shows subscriber counts (if any) */ const TierStatisticsBar = (_param)=>{
    var { stats } = _param, remainingProps = _object_without_properties(_param, [
        "stats"
    ]);
    const { t } = useTranslation();
    const numSubscribers = stats === null || stats === void 0 ? void 0 : stats.subscribers;
    if (!numSubscribers) {
        return null;
    }
    const statItems = [
        {
            icon: TierIcon,
            label: t('deviationview.tierCard.subscribers', {
                count: numSubscribers
            })
        }
    ];
    return /*#__PURE__*/ React.createElement(StatisticsBar, _object_spread_props(_object_spread({}, remainingProps), {
        stats: statItems
    }));
};
TierStatisticsBar.displayName = 'TierStatisticsBar';
export default TierStatisticsBar;
